import React from "react";
import CardDash from "./CardDash";
import Yields from "./Yields";
import Misps from "./Misps";
import CommonCrops from "./CommonCrops";
import LeafletMap from "./LeafletMap";

function DashboardFlid() {
  return (
    <>
      <CardDash />
      <div className="mt-[1.69rem] flex lg:flex-row flex-col gap-x-[1.25rem]">
        <Yields />
        <LeafletMap />
      </div>

      <div className="mt-[1.25rem] flex lg:flex-row  flex-col gap-x-[1.25rem] w-full h-[500px]">
        <Misps />
        <CommonCrops />
      </div>
    </>
  );
}

export default DashboardFlid;
